<div class="container-fluid">

    <h1>Index</h1>
    <div class="d-flex gap-2">
        <a href="/login">Login</a>
        <a href="/dashboard">Dashboard</a>
        <a href="/details">Details</a>
    </div>

    <h2 class="my-2">Select atoms</h2>
    <div class="row" [formGroup]="testForm">
        <!-- <div class="col-4 mb-2">
            <div class="label">Totale hypotheek</div>
            <atom-input-currency
                [width]="'220px'"
                [formControl]="MortgageTotal"
            >
                <div pre>
                    <atom-image
                        [type]="'icon'"
                        [src]="icons.Euro">
                    </atom-image>
                </div>
            </atom-input-currency>
        </div>
        <div class="col-4 mb-2">
            <div class="mb-1">Test default select; displayOption === 'name'</div>
            <atom-select
                [options]="applicationTypeSelectOptions_Single"
                [displayOption]="'name'"
                [placeholder]="'Oversluiter'"
                [control]="applicationTypeControl_Single">
            </atom-select>
        </div> -->
    </div>
    <div class="row">
        <div class="col-4">
            <button (click)="onSubmitForm()">Submit form</button>
        </div>
    </div>

</div>
